function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import map from 'lodash/map';
var _React_PureComponent;
class InputLikeCheckboxRadioGroup extends (_React_PureComponent = React.PureComponent) {
    renderChild(child) {
        if (!child) {
            return null;
        }
        const { inputValue, containerClassName } = child.props;
        const id = child.id || this.props.id;
        return /*#__PURE__*/ _jsx("div", {
            className: cn(containerClassName),
            children: /*#__PURE__*/ React.cloneElement(child, _object_spread_props(_object_spread({}, child.props), {
                id,
                value: this.props.value
            }))
        }, inputValue);
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "row",
            children: map(this.props.children, (child)=>this.renderChild(child))
        });
    }
}
_define_property(InputLikeCheckboxRadioGroup, "propTypes", {
    id: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ])
});
export default InputLikeCheckboxRadioGroup;
